/**
 * Shared styled components for tag-style cell editors.
 * Used by EmailTagCellEditor, StringTagCellEditor, and similar editors.
 */
import {
    colorAttentionBlue10,
    colorAttentionRed50,
    colorFunctionalGray30,
    colorLayoutBorder,
    colorMiscBlue20,
    colorMiscBlue70,
    fontSizeM,
    fontSizeS,
    spacingS,
    spacingXs,
    spacingXxs,
} from "@rhumbix/rmbx_design_system_web"
import styled from "styled-components"

export const TagEditorContainer = styled.div`
    width: 100%;
    min-width: 300px;
    padding: ${spacingXs};
    background: white;
    border: 1px solid ${colorLayoutBorder};
    border-radius: ${spacingXs};
    position: relative;
`

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${spacingXs};
    align-items: center;
    min-height: 32px;
    padding: ${spacingXs};
`

export const Tag = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${colorAttentionBlue10};
    border-radius: ${spacingXs};
    height: 30px;
    max-width: 100%;
    padding: ${spacingXxs} ${spacingXs} ${spacingXxs} ${spacingS};
    font-size: ${fontSizeM};
    color: ${colorMiscBlue70};

    &:hover {
        background-color: ${colorMiscBlue20};
    }
`

export const TagText = styled.span`
    flex: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: ${spacingS};
    text-align: left;
`

export const RemoveButton = styled.button`
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    min-height: 30px;
    max-width: 30px;
    border: none;
    background: transparent;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    border-radius: ${spacingXxs};
`

export const TagInput = styled.input`
    flex: 1;
    min-width: 150px;
    border: none;
    outline: none;
    font-size: ${fontSizeM};
    padding: ${spacingXs};
    background: transparent;

    &::placeholder {
        color: ${colorFunctionalGray30};
    }
`

export const ErrorMessage = styled.div`
    color: ${colorAttentionRed50};
    font-size: ${fontSizeS};
    margin-top: ${spacingXs};
    padding: 0 ${spacingXs};
`
